import React, { useState, useRef, useContext } from 'react';
import {
    Title,
    Content,
    Icon,
    Header,
    Container,
    UploadImageContainer,
    ActionButton,
    HeaderTitle,
    WarningMsg,
    WarningMsgDiv,
} from './AddPo.styled';
import { useTranslation } from 'react-i18next';
import InputBox from 'src/common/refactoredComponents/input/Input';
import ModalDialog from 'src/common/refactoredComponents/modalDialog/modalDialog';
import Close from 'src/assets/images/CloseProduct.svg';
import { useDispatch, useSelector } from 'react-redux';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import PoImageDeleteView from './PoImageDeleteView';
import {
    usageAttachmentUpload,
    deleteAttachmentRequest,
    resetPoDetails,
    setPONonTissueImageDetails,
    setPOTissueImageDetails,
    getPoImagePreview,
    resetPoImagePreview,
} from 'src/pages/reportUsage/redux/action/actionCreators';
import { sizes } from 'src/styles/Media.styled';
// import { REGEX_WITH_SPECIFIC_CHAR } from 'src/constants/appConstants';
import { ReportUsageContext } from 'src/pages/reportUsage';
import {
    checkPoFileExtension,
    itemsWithSamePoNumberAndImage,
} from 'src/utils/util';
import Spinner from 'src/common/refactoredComponents/spinner/Spinner';
import Backdrop from 'src/common/refactoredComponents/backdrop/Backdrop';
import PoImagePreview from './PoImagePreview';
import AlertMsg from 'src/pages/reportUsage/common/AlertMsg';
import { multipleImageWarningMsg } from 'src/pages/reportUsage/utils/dataModificaionUtil';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
import StyledText from 'src/common/refactoredComponents/styledText/StyledText';
import {
    SEMANTIC_TEXT_PX,
    TITLE_FONT_COLOR,
    FONT_FAMILY_DEMI,
} from 'src/styles/fonts/MCFontConstants';

const AddPo = ({ handleClose, selectedProduct, handleApply, onFlagChange }) => {
    const [poNumber, setPoNumber] = useState('');
    const [inputError, setInputError] = useState(false);
    const [warningMsg, setWarningMsg] = useState(false);
    const [warningText, setWarningText] = useState('');
    const [previewImage, setPreviewImage] = useState(false);
    const [imageWarningMsg, setImageWarningMsg] = useState('');
    const [multipleImageWarning, setMultipleImageWarning] = useState(false);
    const dispatch = useDispatch();
    const fileInput = useRef(null);
    const { usageDetails } = useContext(ReportUsageContext);

    const { isHCPOAccountNonTissue, isHCPOAccountTissue } = usageDetails;
    const {
        myCaseRefId,
        poTissueImageDetails,
        poNonTissueImageDetails,
        poImageUploadLoader,
    } = useSelector((state) => state.reportUsageRootReducer);
    const countryISOCode = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.countryISOCode
    );
    const isPoImageRequired = selectedProduct.some(
        (item) =>
            (item.salesOrg === 'S030' && isHCPOAccountTissue) ||
            (item.salesOrg !== 'S030' && isHCPOAccountNonTissue)
    );
    const { t } = useTranslation();
    useEffectWithErrorLogging(() => {
        validateHCPOImage();
    }, [poNumber, poTissueImageDetails, poNonTissueImageDetails]);

    useEffectWithErrorLogging(() => {
        const { isAllItemsHaveSamePoNumber, isAllItemsHaveSameImages } =
            itemsWithSamePoNumberAndImage(selectedProduct);
        const isMulipleItemSelected = selectedProduct.length > 1;

        if (isMulipleItemSelected) {
            const isPOAdded = selectedProduct.some(
                (item) => item.payment && Object.keys(item.payment).length >= 1
            );
            if (!isPOAdded) {
                return;
            }
        }
        if (
            isMulipleItemSelected &&
            isAllItemsHaveSamePoNumber &&
            !isAllItemsHaveSameImages
        ) {
            setPoNumber(selectedProduct[0]?.payment?.poNumber);
            setMultipleImageWarning(true);
        } else if (isMulipleItemSelected && !isAllItemsHaveSamePoNumber) {
            setMultipleImageWarning(true);
        } else {
            if (isAllItemsHaveSamePoNumber) {
                setPoNumber(selectedProduct[0]?.payment?.poNumber);
            }
            const item = selectedProduct[0];
            if (
                isAllItemsHaveSameImages &&
                item?.payment?.poAttachment?.length > 1 &&
                (countryISOCode === 'US'
                    ? item.salesOrg === 'S002'
                    : item.salesOrg !== 'S030')
            ) {
                dispatch(setPONonTissueImageDetails(item.payment.poAttachment));
            } else if (
                isAllItemsHaveSameImages &&
                item?.payment?.poAttachment?.length > 1 &&
                item.salesOrg === 'S030'
            ) {
                dispatch(setPOTissueImageDetails(item.payment.poAttachment));
            }
        }
    }, [selectedProduct]);

    const validateHCPOImage = () => {
        if (poNumber != '') {
            let tissueError = false;
            let nonTissueError = false;
            let errroMsg = '';
            selectedProduct.map((item) => {
                if (item.salesOrg === 'S030') {
                    //tissue
                    let validateImage =
                        isHCPOAccountTissue && poTissueImageDetails === ''
                            ? true
                            : false;
                    if (validateImage) {
                        tissueError = true;
                    }
                } else {
                    let validateImage =
                        isHCPOAccountNonTissue && poNonTissueImageDetails === ''
                            ? true
                            : false;
                    if (validateImage) {
                        nonTissueError = true;
                    }
                }
            });
            if (tissueError && nonTissueError) {
                errroMsg = 'PO Image for both Tissue and Nontissue is Required';
            } else if (tissueError) {
                errroMsg = 'PO Image Required for Tissue';
            } else if (nonTissueError) {
                errroMsg = 'PO Image Required for Non-Tissue';
            } else {
                errroMsg = '';
            }
            setImageWarningMsg(errroMsg);
        }
    };
    const filesValidation = (files) => {
        let fileSizeError = false;
        let fileExtensionError = false;
        for (let i = 0; i < files.length; i++) {
            if (!checkPoFileExtension(files[i].name)) {
                fileExtensionError = true;
                setWarningText(t('equity.shipping.pleaseselectextension'));
                setWarningMsg(true);
                break;
            }
            if (files[i].size >= 10485760) {
                fileSizeError = true;
                setWarningText(t('equity.shipping.filesixenot20mb'));
                setWarningMsg(true);
                break;
            }
        }

        return !fileExtensionError && !fileSizeError;
    };

    const onFileChange = (event) => {
        if (filesValidation(event.target.files)) {
            let tissueProductCount = 0;
            let nonTissueProductCount = 0;
            selectedProduct.map((item) => {
                if (
                    countryISOCode === 'US'
                        ? item.salesOrg === 'S002'
                        : item.salesOrg !== 'S030'
                ) {
                    nonTissueProductCount = nonTissueProductCount + 1;
                } else if (item.salesOrg === 'S030') {
                    tissueProductCount = tissueProductCount + 1;
                }
            });

            dispatch(
                usageAttachmentUpload({
                    tissue: tissueProductCount >= 1,
                    nonTissue: nonTissueProductCount >= 1,
                    files: event.target.files,
                    myCaseRef: myCaseRefId,
                })
            );
            setWarningText('');
            setWarningMsg(false);
            event.target.value = '';
            fileInput.current.value = '';
        }
    };
    const onDeleteClick = (fileName, isTissue) => {
        const object = {
            fileName,
            isTissue,
        };
        dispatch(deleteAttachmentRequest(object));
    };
    const handleApplyClick = (e) => {
        const updatedPoObject = selectedProduct.map((item) => {
            if (item.salesOrg === 'S030') {
                //tissue
                const object = {
                    poAttachment:
                        poTissueImageDetails != '' ? poTissueImageDetails : '',
                    poNumber: poNumber,
                };
                return {
                    ...item,
                    payment: object,
                    isPoImageError: false,
                    poImageErrorMsg: '',
                };
            } else {
                const object = {
                    poAttachment:
                        poNonTissueImageDetails != ''
                            ? poNonTissueImageDetails
                            : '',
                    poNumber: poNumber,
                };
                return {
                    ...item,
                    payment: object,
                    isPoImageError: false,
                    poImageErrorMsg: '',
                };
            }
        });
        dispatch(resetPoDetails());
        handleApply(updatedPoObject);
        onFlagChange(true);
        e.preventDefault();
    };
    const onClose = () => {
        // dispatch(resetPoDetails());
        setPoNumber('');
        setWarningMsg(false);
        handleClose(false);
        setWarningMsg('');
        dispatch(setPOTissueImageDetails(''));
        dispatch(setPONonTissueImageDetails(''));
        onFlagChange(true);
    };

    const checkInputNdValidate = (val) => {
        // const inputValidation = REGEX_WITH_SPECIFIC_CHAR;
        setPoNumber(val);
        // if (inputValidation.test(val)) {
        //     setInputError(false);
        // } else {
        //     setInputError(true);
        // }
    };
    const InputErrorMessage = t('common.invalidCharactersError');

    const openImagePreview = (fileName) => {
        if (fileName) {
            const object = {
                fileName,
            };
            dispatch(getPoImagePreview(object));
            setPreviewImage(true);
        }
    };
    const closeImagePreview = () => {
        setPreviewImage(false);
        dispatch(resetPoImagePreview());
    };
    return (
        <>
            <ModalDialog
            id="reportUsage-reportPayment-addPo"
                modalHeight={'fit-content'}
                modalWidth={'50%'}
                // maxWidth={'841px'}
                zIndex={'10000'}
                padding="15px 10px"
                marginTop="6.75rem"
                handleClose={() => onClose()}
            >
                {poImageUploadLoader ? (
                    <>
                        <Backdrop
                            showCloseButton={false}
                            showBackdrop={true}
                            isModal
                            loaderBackground
                        >
                            <Spinner
                                id="reportUsage-addPo-backdrop-loadingSpinner"
                                animation="border"
                                variant="primary"
                                small
                            />
                        </Backdrop>
                    </>
                ) : null}
                <Container>
                    <Header>
                        <HeaderTitle>
                            {t('consignmentBilling.addPoButton.addPo')}
                        </HeaderTitle>
                        {/* <Icon
                            id="add-po-popup-close-icon"
                            style={{ marginBottom: '12px' }}
                            path={Close}
                            onClick={onClose}
                        /> */}
                    </Header>
                    <Content>
                        <Title showAstrisk={true}>
                            {t(
                                'consignmentBilling.payment.reportPayment.PoNumber'
                            )}
                        </Title>
                        <InputBox
                            placeholder={t(
                                'reportUsage.record.reportPayment.AddPo.enterPO'
                            )}
                            width={
                                window.innerWidth > sizes.mobileDevice
                                    ? '60%'
                                    : '100%'
                            }
                            // value={attnValue}
                            value={poNumber}
                            id={'reportUsage-reportPayment-addPo-poNumber'}
                            onChange={(e) =>
                                checkInputNdValidate(e.target.value)
                            }
                        />
                        {inputError ? (
                            <WarningMsg>{InputErrorMessage}</WarningMsg>
                        ) : null}

                        <UploadImageContainer
                        id="reportUsage-reportPayment-addPo-uploadImage"
                            onClick={() =>
                                fileInput.current && fileInput.current.click()
                            }
                        >
                            <StyledText
                                fontColor={TITLE_FONT_COLOR}
                                fontSize={SEMANTIC_TEXT_PX}
                                fontFamily={FONT_FAMILY_DEMI}
                                showRedAsterisk={isPoImageRequired}
                            >
                                {isPoImageRequired
                                    ? t('equity.shipping.addPoNonTissue.POImageR')
                                    : t('equity.shipping.addPoNonTissue.POImageO')}
                            </StyledText>
                        </UploadImageContainer>
                        {warningMsg ? (
                            <WarningMsg>{warningText}</WarningMsg>
                        ) : null}
                        {imageWarningMsg != '' && (
                            <WarningMsg>{imageWarningMsg}</WarningMsg>
                        )}
                        <input
                            onChange={onFileChange}
                            id="reportUsage-reportPayment-file-upload"
                            type="file"
                            // accept=".jpg,.jpeg,.gif,.png,.tif,.tiff,.pdf,.bmp,.msg,.doc,.docx,.xls,.txt,.html"
                            hidden
                            ref={fileInput}
                            multiple
                        />
                        {poTissueImageDetails != ''
                            ? poTissueImageDetails
                                .split(',')
                                .map((fileName, index) => (
                                    <PoImageDeleteView
                                        id={`reportUsage-reportPayment-addPo-tissueImage-${index}`}
                                        previewImage={openImagePreview}
                                        key={index}
                                        onDelete={(fileName) =>
                                            onDeleteClick(fileName, true)
                                        }
                                        name={fileName}
                                    />
                                ))
                            : null}
                        {poNonTissueImageDetails != ''
                            ? poNonTissueImageDetails
                                .split(',')
                                .map((fileName, index) => (
                                    <PoImageDeleteView
                                        id={`reportUsage-reportPayment-addPo-nonTissueImage-${index}`}
                                        key={index}
                                        onDelete={(fileName) =>
                                            onDeleteClick(fileName, false)
                                        }
                                        name={fileName}
                                        previewImage={openImagePreview}
                                    />
                                ))
                            : null}
                        {multipleImageWarning && (
                            <WarningMsgDiv>
                                <AlertMsg message={multipleImageWarningMsg()} />
                            </WarningMsgDiv>
                        )}
                    </Content>
                    <ActionButton>
                        <Button
                            id={'reportUsage-reportPayment-record-AddPo-apply-button'}
                            show={true}
                            // primary={
                            //     poNumber == '' ||
                            //     imageWarningMsg != '' ||
                            //     inputError
                            //         ? false
                            //         : true
                            // }
                            height="38px"
                            width={
                                window.innerWidth > sizes.mobileDevice
                                    ? '50%'
                                    : '80%'
                            }
                            disabled={
                                (
                                poNumber == '' ||
                                    imageWarningMsg != '' ||
                                    inputError
                                    ? true
                                    : false
                                ) && ButtonStyles?.primary
                            }
                           variant={(poNumber === '' || imageWarningMsg !== '' || inputError) ? ButtonStyles.disabled  :  ButtonStyles.primary}
                            clicked={handleApplyClick}
                            fontSize={'15px'}
                        >
                            {`${t(
                                'consignmentBilling.payment.reportPayment.applyToSelected'
                            )} (${selectedProduct.length})`}
                        </Button>
                    </ActionButton>
                </Container>
            </ModalDialog>
            {previewImage && (
                <PoImagePreview
                    closePoImagePreview={closeImagePreview}
                />
            )}
        </>
    );
};

export default AddPo;
